// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
    display: flex;
    min-height: 100vh;
    width: 100%;
    align-items: center;
    justify-content: center;
    min-width: 320px;
}

.content-half {
    flex: 1 1;
    padding-left: 0px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    min-width: 0;
}

.content-half.right {
    background-color: #F4F4F4;
    padding-left: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 0;
}

.ai-hub-login {
    width: 100%;
    height: auto;
    max-width: 576px;
    margin: 0 auto;
    padding: 20px;
    object-fit: contain;
}

.login-con {
    display: flex;
    height: 100vh;
    min-height: 60vh;
    position: relative;
    overflow: hidden;
}

.login-to {
    margin-top: 54px;
    color: #000;
    font-family: "Henkel GT Flexa", sans-serif;
    font-size: 32px;
    font-style: normal;
    font-weight: 500;
    line-height: 48px;
    /* 150% */
}

.henkel-ai {
    color: #000;
    font-family: "Henkel GT Flexa", sans-serif;
    ;
    font-size: 44px;
    font-style: normal;
    font-weight: 500;
    line-height: 48px;
    /* 109.091% */
}

/* Prevent scrollbars on body when modal is open */
body.login-modal-open {
    overflow: hidden;
}

.login-left-logo {
    width: 549px;
    height: 425px;
}

.login-main-con {
    height: 725px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    max-width: 576px;
    padding-left: 107px;
}

.banklog {
    width: 130px;
    height: 96px;
}

.login-main-title {
    width: 100%;
    object-fit: contain;
}

.login-btn {
    width: 130%;
    height: 48px;
    border-radius: 16px;
    background-color: #000000;
    color: #ffffff;
    text-align: center;
    line-height: 48px;
    font-family: Segoe UI, sans-serif;
    font-weight: 400;
    font-size: 16px;
    letter-spacing: 0%;
    cursor: pointer;
    margin-top: 47px;
}

.login-btn:hover {
    background-color: #C1D3DC;
}

.login-main {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.login-logo {
    width: 197px;
    height: 97px;
    font-family: Inter, sans-serif;
    font-weight: 500;
    font-style: italic;
    font-size: 80px;
    line-height: 96.82px;
    letter-spacing: 0%;
    color: #FFFFFF;
    margin-bottom: 12px;
}

.login-title {
    font-family: Inter, sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 19.36px;
    letter-spacing: 0%;
    color: rgba(255, 255, 255, 0.5);
    margin-bottom: 68px;
}


.login-spin-myid {
    background: rgba(255, 255, 255, 0.5);
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    z-index: 1000;
    overflow: hidden;
}

.login-main-footer {
    position: absolute;
    bottom: 104px;
    left: 108px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.login-new-lang {
    color: rgba(255, 255, 255, 0.5);
    font-family: 'Segoe UI', sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 21px;
    display: flex;
    align-items: center;
    cursor: pointer;
    position: absolute;
    top: 33px;
    right: 40px;
}

.login-new-lang-line {
    display: inline-block;
    margin: 0 12px;
    font-size: 14px;
    line-height: 14px;
}

.login-new-lang-main {
    color: rgba(255, 255, 255, 0.9);
    cursor: default
}

@media (min-width: 1201px) {
    .login-main-con {
        margin-top: 40%;
    }
}

@media (width > 1600px) {
    .login-main-con {
        margin-top: 20%;
    }
    
    .login-main-news {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    height: 100%;
    
}
 .login-btn {
        width: 100%;
    }
}

/* 响应式布局调整 */
@media (max-width: 1200px) {
    /* .content-half {
        padding-left: 60px;
    } */
    
    .login-main-con {
        padding-top: 30%;
    }
    .login-btn {
        width: 130%;
    }
}


@media (max-width: 768px) {
    .login-container {
        flex-direction: row;
    }
        .login-btn {
        width: 120%;
    }
    .content-half {
        padding-left: 20px;
        padding-right: 10px;
        align-items: flex-start;
        text-align: left;
    }
    
    .login-to {
        font-size: 24px;
        line-height: 36px;
    }
    
    .henkel-ai {
        font-size: 32px;
        line-height: 40px;
    }
    
    .login-btn {
        width: 120%;
    }
    
    .login-main-con {
        padding-top: 40px;
        align-items: flex-start;
        text-align: left;
        max-width: 350px;
    }
    
    .content-half.right {
        padding: 10px;
    }
    
    .ai-hub-login {
        padding: 10px;
    }
}

@media (max-width: 480px) {
    .login-container {
        flex-direction: row;
    }
    
    .content-half {
        padding-left: 10px;
        padding-right: 5px;
        align-items: flex-start;
        text-align: left;
    }
    
    .login-to {
        font-size: 18px;
        line-height: 28px;
    }
    
    .henkel-ai {
        font-size: 24px;
        line-height: 32px;
    }
    
    .login-main-con {
        align-items: flex-start;
        text-align: left;
        max-width: 280px;
        padding-top: 30px;
    }
    
    .login-btn {
        width: 100%;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
    }
    
    .content-half.right {
        padding: 5px;
    }
    
    .ai-hub-login {
        padding: 5px;
    }
    
    .banklog {
        width: 100px;
        height: 74px;
    }
}

.login-spin-myid-dis {
    display: none;
}

.login-loading-content {
    background-color: rgba(255, 255, 255, 0.5);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.login-loading-gif {
    width: 50px;
    height: 50px;
    margin-bottom: 16px;
}

.login-loading-text {
    color: #000;
    font-size: 12px;
    margin-top: -15px;
    margin-right: -5px;
    font-family: sans-serif;
}`, "",{"version":3,"sources":["webpack://./src/pages/login/index.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,iBAAiB;IACjB,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,iBAAiB;IACjB,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,0CAA0C;IAC1C,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,0CAA0C;;IAE1C,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;AACjB;;AAEA,kDAAkD;AAClD;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,iCAAiC;IACjC,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,+BAA+B;IAC/B,mBAAmB;AACvB;;;AAGA;IACI,oCAAoC;IACpC,WAAW;IACX,aAAa;IACb,eAAe;IACf,MAAM;IACN,OAAO;IACP,aAAa;IACb,uBAAuB;IACvB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,+BAA+B;IAC/B,mCAAmC;IACnC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,+BAA+B;IAC/B;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;IACA,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX,YAAY;;AAEhB;CACC;QACO,WAAW;IACf;AACJ;;AAEA,YAAY;AACZ;IACI;;OAEG;;IAEH;QACI,gBAAgB;IACpB;IACA;QACI,WAAW;IACf;AACJ;;;AAGA;IACI;QACI,mBAAmB;IACvB;QACI;QACA,WAAW;IACf;IACA;QACI,kBAAkB;QAClB,mBAAmB;QACnB,uBAAuB;QACvB,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,iBAAiB;QACjB,uBAAuB;QACvB,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,kBAAkB;QAClB,uBAAuB;QACvB,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,uBAAuB;QACvB,gBAAgB;QAChB,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,YAAY;IAChB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,0CAA0C;IAC1C,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,uBAAuB;AAC3B","sourcesContent":[".login-container {\n    display: flex;\n    min-height: 100vh;\n    width: 100%;\n    align-items: center;\n    justify-content: center;\n    min-width: 320px;\n}\n\n.content-half {\n    flex: 1;\n    padding-left: 0px;\n    background-color: #fff;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    min-width: 0;\n}\n\n.content-half.right {\n    background-color: #F4F4F4;\n    padding-left: 0px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-width: 0;\n}\n\n.ai-hub-login {\n    width: 100%;\n    height: auto;\n    max-width: 576px;\n    margin: 0 auto;\n    padding: 20px;\n    object-fit: contain;\n}\n\n.login-con {\n    display: flex;\n    height: 100vh;\n    min-height: 60vh;\n    position: relative;\n    overflow: hidden;\n}\n\n.login-to {\n    margin-top: 54px;\n    color: #000;\n    font-family: \"Henkel GT Flexa\", sans-serif;\n    font-size: 32px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 48px;\n    /* 150% */\n}\n\n.henkel-ai {\n    color: #000;\n    font-family: \"Henkel GT Flexa\", sans-serif;\n    ;\n    font-size: 44px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 48px;\n    /* 109.091% */\n}\n\n/* Prevent scrollbars on body when modal is open */\nbody.login-modal-open {\n    overflow: hidden;\n}\n\n.login-left-logo {\n    width: 549px;\n    height: 425px;\n}\n\n.login-main-con {\n    height: 725px;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    width: 100%;\n    max-width: 576px;\n    padding-left: 107px;\n}\n\n.banklog {\n    width: 130px;\n    height: 96px;\n}\n\n.login-main-title {\n    width: 100%;\n    object-fit: contain;\n}\n\n.login-btn {\n    width: 130%;\n    height: 48px;\n    border-radius: 16px;\n    background-color: #000000;\n    color: #ffffff;\n    text-align: center;\n    line-height: 48px;\n    font-family: Segoe UI, sans-serif;\n    font-weight: 400;\n    font-size: 16px;\n    letter-spacing: 0%;\n    cursor: pointer;\n    margin-top: 47px;\n}\n\n.login-btn:hover {\n    background-color: #C1D3DC;\n}\n\n.login-main {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n}\n\n.login-logo {\n    width: 197px;\n    height: 97px;\n    font-family: Inter, sans-serif;\n    font-weight: 500;\n    font-style: italic;\n    font-size: 80px;\n    line-height: 96.82px;\n    letter-spacing: 0%;\n    color: #FFFFFF;\n    margin-bottom: 12px;\n}\n\n.login-title {\n    font-family: Inter, sans-serif;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 19.36px;\n    letter-spacing: 0%;\n    color: rgba(255, 255, 255, 0.5);\n    margin-bottom: 68px;\n}\n\n\n.login-spin-myid {\n    background: rgba(255, 255, 255, 0.5);\n    width: 100%;\n    height: 100vh;\n    position: fixed;\n    top: 0;\n    left: 0;\n    display: flex;\n    justify-content: center;\n    z-index: 1000;\n    overflow: hidden;\n}\n\n.login-main-footer {\n    position: absolute;\n    bottom: 104px;\n    left: 108px;\n    height: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n.login-new-lang {\n    color: rgba(255, 255, 255, 0.5);\n    font-family: 'Segoe UI', sans-serif;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 21px;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    position: absolute;\n    top: 33px;\n    right: 40px;\n}\n\n.login-new-lang-line {\n    display: inline-block;\n    margin: 0 12px;\n    font-size: 14px;\n    line-height: 14px;\n}\n\n.login-new-lang-main {\n    color: rgba(255, 255, 255, 0.9);\n    cursor: default\n}\n\n@media (min-width: 1201px) {\n    .login-main-con {\n        margin-top: 40%;\n    }\n}\n\n@media (width > 1600px) {\n    .login-main-con {\n        margin-top: 20%;\n    }\n    \n    .login-main-news {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    width: 100%;\n    height: 100%;\n    \n}\n .login-btn {\n        width: 100%;\n    }\n}\n\n/* 响应式布局调整 */\n@media (max-width: 1200px) {\n    /* .content-half {\n        padding-left: 60px;\n    } */\n    \n    .login-main-con {\n        padding-top: 30%;\n    }\n    .login-btn {\n        width: 130%;\n    }\n}\n\n\n@media (max-width: 768px) {\n    .login-container {\n        flex-direction: row;\n    }\n        .login-btn {\n        width: 120%;\n    }\n    .content-half {\n        padding-left: 20px;\n        padding-right: 10px;\n        align-items: flex-start;\n        text-align: left;\n    }\n    \n    .login-to {\n        font-size: 24px;\n        line-height: 36px;\n    }\n    \n    .henkel-ai {\n        font-size: 32px;\n        line-height: 40px;\n    }\n    \n    .login-btn {\n        width: 120%;\n    }\n    \n    .login-main-con {\n        padding-top: 40px;\n        align-items: flex-start;\n        text-align: left;\n        max-width: 350px;\n    }\n    \n    .content-half.right {\n        padding: 10px;\n    }\n    \n    .ai-hub-login {\n        padding: 10px;\n    }\n}\n\n@media (max-width: 480px) {\n    .login-container {\n        flex-direction: row;\n    }\n    \n    .content-half {\n        padding-left: 10px;\n        padding-right: 5px;\n        align-items: flex-start;\n        text-align: left;\n    }\n    \n    .login-to {\n        font-size: 18px;\n        line-height: 28px;\n    }\n    \n    .henkel-ai {\n        font-size: 24px;\n        line-height: 32px;\n    }\n    \n    .login-main-con {\n        align-items: flex-start;\n        text-align: left;\n        max-width: 280px;\n        padding-top: 30px;\n    }\n    \n    .login-btn {\n        width: 100%;\n        height: 40px;\n        line-height: 40px;\n        font-size: 14px;\n    }\n    \n    .content-half.right {\n        padding: 5px;\n    }\n    \n    .ai-hub-login {\n        padding: 5px;\n    }\n    \n    .banklog {\n        width: 100px;\n        height: 74px;\n    }\n}\n\n.login-spin-myid-dis {\n    display: none;\n}\n\n.login-loading-content {\n    background-color: rgba(255, 255, 255, 0.5);\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.login-loading-gif {\n    width: 50px;\n    height: 50px;\n    margin-bottom: 16px;\n}\n\n.login-loading-text {\n    color: #000;\n    font-size: 12px;\n    margin-top: -15px;\n    margin-right: -5px;\n    font-family: sans-serif;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
